import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import faqs from '../../data/faqs';
import { scrollToAnchor } from '../../utils/scrollUtils';
import './help-support.css';

const HelpSupport = ({ language }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  // Holds anchor to scroll to after accordion opens
  const pendingScrollRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // Consume searchTarget from SearchBar navigation
  useEffect(() => {
    const target = location.state?.searchTarget;
    if (!target?.anchor) return;

    const m = target.anchor.match(/^faq-(\d+)$/);
    if (!m) return;

    const idx = parseInt(m[1], 10);
    pendingScrollRef.current = target.anchor;
    setOpenIndex(idx);

    navigate(location.pathname, { replace: true, state: {} });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // After accordion opens (openIndex changes), scroll to the item
  useEffect(() => {
    if (!pendingScrollRef.current) return;
    const anchor = pendingScrollRef.current;
    pendingScrollRef.current = null;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToAnchor(anchor);
      });
    });
  }, [openIndex]);

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

  const pageTitle = language === 'hi' ? 'सहायता एवं समर्थन' : 'Help & Support';
  const homeLabel = language === 'hi' ? 'मुख्य पृष्ठ' : 'Home';

  return (
    <div>
      {/* Banner header — matches all other inner pages */}
      <div

      
        className="inner-pages-head"
        style={{ backgroundImage: "url('images/about-header-bg.jpg')" }}
      >
        <div className="container">
          <div className="title_and_breadcrumbs">
            <h1>{pageTitle}</h1>
            <ul>
              <li><Link to="/">{homeLabel}</Link></li>
              <span></span>
              <li>{pageTitle}</li>
            </ul>
          </div>
          <div className="banner-logo">
            <img src="images/mahabharat-logo.svg" alt="" />
          </div>
        </div>
      </div>

      {/* FAQ accordion */}
      <section className="faq-section">
        <div className="container">
          <h2 className="faq-section-title">Frequently Asked Questions</h2>
          <p className="faq-section-sub">
            Everything you need to know before your visit
          </p>

          <ul className="faq-list">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <li id={`faq-${i}`} key={i} className={`faq-item${isOpen ? ' faq-item--open' : ''}`}>
                  <button
                    className="faq-question"
                    aria-expanded={isOpen}
                    onClick={() => toggle(i)}
                  >
                    <span>{faq.question}</span>
                    <svg
                      className="faq-chevron"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {isOpen && (
                    <p className="faq-answer">{faq.answer}</p>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default HelpSupport;
